// image-skeleton.js — muestra un placeholder con shimmer mientras cargan las imágenes
// de producto (tarjetas, miniaturas del PDP, miniaturas de vista rápida y resultados
// del buscador), y hace un fade-in al cargar. Evita los cuadros blancos/vacíos.
(function () {
  'use strict';
  // Solo imágenes de producto reales; NO el hover de la tarjeta ni logos/íconos.
  var SEL = [
    '.product-article__figure img.product-article__figure--primary',
    '.product-article-second__figure img',
    '.pdp2-vthumb img',
    '.qv-modal__thumb img',
    '.nike-search__card-img img'
  ].join(',');

  function markLoaded(img) {
    img.classList.add('is-img-loaded');
    var p = img.parentElement;
    if (p) p.classList.add('is-img-loaded');
  }

  function wire(img) {
    var p = img.parentElement;
    if (!p || p.classList.contains('img-skel')) return; // ya procesada
    p.classList.add('img-skel');
    img.classList.add('img-skel-img');
    if (img.complete && img.naturalWidth > 0) { markLoaded(img); return; }
    img.addEventListener('load', function () { markLoaded(img); }, { once: true });
    img.addEventListener('error', function () {
      // Si falla, quitar el skeleton para no dejar el hueco animado eternamente
      p.classList.remove('img-skel');
      img.classList.remove('img-skel-img');
    }, { once: true });
  }

  function scan(root) {
    if (root.querySelectorAll) root.querySelectorAll(SEL).forEach(wire);
    if (root.matches && root.matches(SEL)) wire(root);
  }

  function init() { scan(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Contenido dinámico: modal de vista rápida, resultados del buscador, carga por scroll.
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        if (added[j].nodeType === 1) scan(added[j]);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
